module.exports = __webpack_public_path__ + "static/media/website.a338def4.png";